import { GET_INTERVIEW_PROGRESS } from '@/stores/actions.type';
import { NOTIFICATION_TYPES, NotificationService } from '@/services/notification.service';

const ProgressPollingMixin = {
  data: () => ({
    pollInterval: null,
    pollingIntervalMs: 5000 // Default to 5 seconds (was previously used in interview.client.mixin.js)
  }),
  
  methods: {
    /**
     * Begin polling for interview progress
     * Sets up an interval to repeatedly check progress status
     * @param {Number} intervalMs - Optional custom interval in milliseconds
     */
    startPolling(intervalMs) {
      this.fetchProgress();
      
      const interval = intervalMs || this.pollingIntervalMs;
      
      this.pollInterval = setInterval(() => {
        this.fetchProgress();
      }, interval);
    },

    /**
     * Stop polling for interview progress
     * Clears the polling interval
     */
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },

    /**
     * Fetch interview progress from the server
     * Only fetches if we're not finishing and not complete
     */
    fetchProgress() {
      if (this.finishing || this.isAllComplete) {
        // Stop polling if we're either finishing or complete
        if (this.isAllComplete) {
          this.stopPolling();
        }
        return;
      }
      
      this.$store.dispatch(GET_INTERVIEW_PROGRESS)
        .catch((error) => {
          console.error('Error fetching progress:', error);
          NotificationService.alert({
            type: NOTIFICATION_TYPES.ERROR,
            title: 'Sync Error',
            message: 'Failed to check interview progress. Please try again.',
            okTitle: 'Ok'
          });
        });
    },

    /**
     * Check sync status of all items
     * @returns {Boolean} Whether all items are synced
     */
    checkSyncStatus() {
      if (!this.clientProgress || !this.clientProgress.progress) {
        console.log('Client progress data is not available');
        return false;
      }
      
      // Check if any items are still syncing (IN_PROGRESS) or have failed (FAILED)
      return !this.clientProgress.progress.some(
        item => item.status === 'IN_PROGRESS' || item.status === 'FAILED'
      );
    }
  },
  
  beforeDestroy() {
    this.stopPolling();
  }
};

export default ProgressPollingMixin; 